import React from 'react';

import SnackBarAlert from './SnackBarAlert-View';

const SnackBarAlertContainer = props => <SnackBarAlert {...props} />;

export default SnackBarAlertContainer;
